import { Parser } from "@siteimprove/alfa-parser";
import {} from "../syntax/index.js";
import { Keyword } from "./textual/keyword.js";
const { either } = Parser;
/**
 * @public
 */
export var Box;
(function (Box) {
    Box.parse = Keyword.parse("border-box", "padding-box", "content-box");
    Box.parseShape = either(Box.parse, Keyword.parse("margin-box"));
    Box.parseGeometry = either(Box.parseShape, Keyword.parse("fill-box", "stroke-box", "view-box"));
    Box.parseVisualBox = Keyword.parse("content-box", "padding-box", "border-box");
    Box.parsePaintBox = either(Box.parseVisualBox, Keyword.parse("fill-box", "stroke-box"));
    Box.parseCoordBox = either(Box.parsePaintBox, Keyword.parse("view-box"));
})(Box || (Box = {}));
//# sourceMappingURL=box.js.map